import type { RouteObject } from "react-router-dom"
import { useEffect, useState } from "react"
import { useLocation, useRoutes } from "react-router-dom"
import AppShell from "@/components/AppShell"
import AdminPage from "@/pages/AdminPage"
import ComingSoonPage from "@/pages/ComingSoonPage"
import CreatePage from "@/pages/CreatePage"
import ExplorePage from "@/pages/ExplorePage"
import FeedPage from "@/pages/FeedPage"
import MessagesPage from "@/pages/MessagesPage"
import NotificationsPage from "@/pages/NotificationsPage"
import ProfilePage from "@/pages/ProfilePage"
import SettingsPage from "@/pages/SettingsPage"
import WalletPage from "@/pages/WalletPage"
import { isComingSoonEnabled, loadComingSoonSetting } from "@/lib/launch"
import type { SiteSetting } from "@/types"

function isAdminPath(pathname = "", hash = "", search = "") {
  const values = [pathname, hash, search, typeof window !== "undefined" ? window.location.pathname : ""]
  return values.some((value) => /(^|[/?#])admin\/?($|[?#])/.test(String(value || "").toLowerCase()))
}

export const routes: RouteObject[] = [
  { path: "/admin", element: <AdminPage /> },
  { path: "/admin/", element: <AdminPage /> },
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <FeedPage /> },
      { path: "p/:postId", element: <FeedPage /> },
      { path: "explore", element: <ExplorePage /> },
      { path: "create", element: <CreatePage /> },
      { path: "wallet", element: <WalletPage /> },
      { path: "swap", element: <WalletPage /> },
      { path: "reel", element: <WalletPage /> },
      { path: "activity", element: <NotificationsPage /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "messages", element: <MessagesPage /> },
      { path: "messages/:userId", element: <MessagesPage /> },
      { path: "profile", element: <ProfilePage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "u/:userId", element: <ProfilePage /> },
      { path: "auth", element: <FeedPage /> },
      { path: "*", element: <FeedPage /> },
    ],
  },
]

function App() {
  const location = useLocation()
  const [setting, setSetting] = useState<SiteSetting | null>(null)
  const [ready, setReady] = useState(false)
  const element = useRoutes(routes)

  useEffect(() => {
    let active = true
    loadComingSoonSetting()
      .then((row) => {
        if (active) setSetting(row)
      })
      .catch((err) => {
        console.error("Launch setting load failed:", err)
        if (active) setSetting(null)
      })
      .finally(() => {
        if (active) setReady(true)
      })
    return () => {
      active = false
    }
  }, [])

  if (isAdminPath(location.pathname, location.hash, location.search)) {
    return <AdminPage />
  }

  if (!ready) {
    return <div className="min-h-screen bg-black" />
  }

  if (isComingSoonEnabled(setting)) {
    return <ComingSoonPage setting={setting} onSettingChange={setSetting} />
  }

  return element
}

export default App
